import Primary from './Primary'
import Secondary from './Secondary'


export default {
  Primary,
  Secondary
}